require('./RAPieChart.scss');

// @vendors
const React = require('react');
const ReactDOM = require('react-dom');
const PropTypes = require('prop-types');

// @components
const DonutChart = require('components/d3Components/donutChart/donutChart');

// @utilities
const { formatPercentage } = require('../../../utilities/RACurrencyHelper');
const RAAssetsHelper = require('../../../utilities/RAAssetsHelper');

class RAPieChart extends React.Component {
    componentDidMount() {
        const node = ReactDOM.findDOMNode(this); // Only I search for current instance, instead a dangerous document.querySelector so in this way we prevent side effects
        const wrapperEl = node.querySelector(
            '.ra-pie-chart__donut-chart-component--empty',
        );
        const elementHeight = this.props.height + 'px';
        wrapperEl.style.height = elementHeight;

        if (this.props.data.size > 0) {
            // this lines is because DonutChart component ALWAYS has a gray empty circle in the background and we need to implement not only in a
            // a white widget container, we need also implement it in differents backgrounds
            const centralCircleEl = node.querySelector(
                '.ra-pie-chart__central-circle',
            );
            wrapperEl.style.backgroundColor = 'transparent';
            centralCircleEl.style.backgroundColor = 'transparent';
        }
    }

    parseData(data) {
        // added generic data list in order to have always four elements to control Donut classes
        const emptyData = RAAssetsHelper.getEmptyPieAssets();
        const parsedData = emptyData.map(emptyItem => {
            const partialItem = data.find(
                dataItem => dataItem.key == emptyItem.key,
            );
            const item = partialItem || emptyItem;
            return {
                key: item.key.toLowerCase(), // added this lowercase method in order to prevent Sass lintern BEM warning
                label: item.label,
                value: formatPercentage(item.value, false),
            };
        });

        return parsedData;
    }

    render() {
        const { data, width, height, weight } = this.props;
        const dataset = this.parseData(data);

        return (
            <div className="ra-pie-chart">
                <DonutChart
                    width={width}
                    height={height}
                    donutWidth={weight}
                    dataset={dataset}
                    namespace="ra-pie-chart"
                />
            </div>
        );
    }
}

RAPieChart.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    width: PropTypes.string,
    height: PropTypes.string,
    weight: PropTypes.string,
};

RAPieChart.defaultProps = {
    width: '180',
    height: '180',
    weight: '35',
};
module.exports = RAPieChart;
